import {TickerData} from "../socket/socket.service";

export interface IContractPositionResponse {
    id: string;
    token: string;
    amount: string;
    status: number;
    realizedPnl: string;
    tp: string;
    sl: string;
}

export interface IPositionResponse {
    id: number;
    status: string;
    symbol: string;
    leverage: number | string;
    token: string;
    amount: string;
    tpPrice: string;
    slPrice: string;
    initialPrice: string;
    isShort: boolean;
    baseAsset: string;
    quoteAsset: string;
    finishedAt?: string | null;
    closedPrice?: string | null;
    closedReason?: string;
    feeAmount?: string;
    profit?: string;
    profitAmount?: string;
    lastPrice?: string;
    startedAt: string;
    fee?: string;
    realizedPnL?: string | null;
    netPnlAmount?: number;
}

export interface IAccountBalance {
    token: string
    availableBalance: string
    marginBalance: string
    withdrawBalance: string
}

export interface IOpenPositionMessage {
    user: string;
    symbol: string;
    token: string;
    amount: string;
    leverage: number;
    nonce: number;
    deadline: number;
}

export interface IDataForWithdrawal {
    message: {
        user: string;
        token: string;
        amount: string;
        nonce: number;
        deadline: number;
    },
    signature: string;
}

export interface IOpenPositionBody {
    message: IOpenPositionMessage;
    signature: string;
    tp?: string;
    sl?: string;
}

export interface IUserObj {
    user: string;
}

export interface IUserWithToken {
    user: string;
    token: string;
}

export interface IToken {
    name: string;
    address: string;
    decimals: number;
}

export interface IMarketData {
    symbol: string;
    baseAsset: string;
    quoteAsset: string;
    ticker: string;
    tokens: IToken[];
    isShort: boolean;
    minLeverage: number;
    maxLeverage: number;
    minVolume: string;
    maxVolume: string;
    settlementFee: string;
    settlementPeriod: string;
    lastTicker?: TickerData
}

export interface MarketHistoryItem {
    open: number
    high: number
    low: number
    close: number
    date_time: number //seconds
}

export interface ChartBar {
    open: number
    high: number
    low: number
    close: number
    time: number //milliseconds
}
export enum MarketHistoryTimeframe {
    '1M' = '1M',
    '5M' = '5M',
    '15M' = '15M',
    '30M' = '30M',
    '1H' = '1H',
    '4H' = '4H',
    '1D' = '1D',
}
export interface IClosePositionMessage {
    user: string;
    positionId: number;
    nonce: number;
    deadline: number;
}

export interface IUpdatePositionMessage extends IClosePositionMessage {
    tp: string;
    sl: string;
}

export interface IUpdatePositionParams {
    message: IUpdatePositionMessage;
    signature: string;
}

export interface IStatByDate {
    date: string;
}

export interface IUsersStatsByDate extends IStatByDate {
    count: string;
}

export interface IVolumeByDate extends IStatByDate {
    volume: string;
}

export interface ITransactionsByDate extends IStatByDate {
    total: string;
    deposits: string;
    withdrawals: string;
    positionOpens: string;
    positionUpdates: string;
    positionCloses: string;
}

export interface IStatsSummary {
    totalVolume: string;
    totalUsers: string;
    totalTxs: string;
}

export interface IClosePositionParams {
    message: IClosePositionMessage;
    signature: string;
}

export interface IDeposit {
    id: string
    createdAt: string
    status: string
    amount: string
    token: string
    blockFound: number
    blockProcessed: number
    txHash: string
}

export interface IWithdrawal {
    id: string
    createdAt: string
    status: string
    amount: string
    token: string
    withdrawTx: string
}